import { logger } from "@/logger";

export const checkApiReachability = async (): Promise<boolean> => {
  try {
    const response = await fetch(import.meta.env.VITE_BACKEND_URL, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.ok;
  } catch (error) {
    logger.error("Error checking API reachability:", error);
    return false;
  }
};
